"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ipBlacklist = require("@/api/ipBlacklist");
var _userAgent = require("@/utils/userAgent");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IpBlacklist',
  data: function data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      page: 1,
      limit: 20,
      queryForm: {
        ip: '',
        status: 'ALL'
      },
      detailVisible: false,
      detailLoading: false,
      detailRow: null,
      detailItems: []
    };
  },
  mounted: function mounted() {
    this.getDataList();
  },
  methods: {
    formatBlockDuration: _ipBlacklist.formatBlockDuration,
    formatBlockUntil: _ipBlacklist.formatBlockUntil,
    displayHeaderValue: _userAgent.displayHeaderValue,
    formatBlockType: function formatBlockType(row) {
      if (!row) return '-';
      var parsed = (0, _ipBlacklist.parseIpBlacklistDetail)(row.detail);
      if (parsed.blockTypeLabel) {
        return parsed.blockTypeLabel;
      }
      return _ipBlacklist.IP_BLACKLIST_TYPE_LABEL[row.blockType] || row.blockType || '-';
    },
    getDataList: function getDataList() {
      var _this = this;
      this.loading = true;
      var params = {
        page: this.page,
        limit: this.limit,
        ip: this.queryForm.ip
      };
      if (this.queryForm.status !== 'ALL') {
        params.status = this.queryForm.status;
      }
      (0, _ipBlacklist.ipBlacklistListApi)(params).then(function (res) {
        _this.dataList = res.list || [];
        _this.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    resetQuery: function resetQuery() {
      this.queryForm = {
        ip: '',
        status: 'ALL'
      };
      this.page = 1;
      this.getDataList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getDataList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getDataList();
    },
    handleDetail: function handleDetail(row) {
      var _this2 = this;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detailRow = null;
      this.detailItems = [];
      (0, _ipBlacklist.ipBlacklistDetailApi)(row.id).then(function (res) {
        _this2.detailRow = res;
        var parsed = (0, _ipBlacklist.parseIpBlacklistDetail)(res.detail);
        _this2.detailItems = parsed.items;
      }).finally(function () {
        _this2.detailLoading = false;
      });
    },
    handleUnblock: function handleUnblock(row) {
      var _this3 = this;
      this.$confirm('确认解封该IP吗？', '提示', {
        type: 'warning'
      }).then(function () {
        (0, _ipBlacklist.ipBlacklistUnblockApi)(row.id).then(function () {
          _this3.$message.success('解封成功');
          _this3.getDataList();
        });
      }).catch(function () {});
    }
  }
};